// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-modal:after {
  content: "";
  position: absolute;
  left: calc(90% - 8px);
  border-style: solid;
  border-width: 0 12px 16px;
  border-color: #FFF transparent;
  display: block;
  width: 0;
  z-index: 1;
}

.filter-modal-text {
  font-size: 14px;
}

ion-content {
  --background: var(--ion-color-primary-contrast);
  --color: var(--ion-text-color);
  --padding-top: 16px;
  --padding-bottom: 16px;
  --padding-start: 16px;
  --padding-end: 16px;
}

ion-list {
  background: transparent;
}

ion-item {
  border-width: 0;
  --inner-border-width: 0;
  --background: transparent;
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
  --ion-background-color: transparent;
  --border-width: 0;
}

ion-label {
  --color: var(--ion-text-color);
}

ion-checkbox {
  margin-inline-end: 8px;
}

ion-toggle {
  margin-inline-end: 8px;
  --background: rgba(0,0,0,.05);
}

hr {
  width: 100%;
  background-color: #eeeeee;
  height: 2px;
}

h5.filter-header {
  margin-top: 2px;
}

.filter-modal .modal-wrapper {
  overflow: auto !important;
  contain: initial;
}

.buttons-container {
  display: flex;
  justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/components/filter-modal/filter-modal.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;EACA,QAAA;EACA,UAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,+CAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,uBAAA;AADJ;;AAIA;ECiBE,eAAA;EAEA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;ADlBF;;AAHA;EACI,8BAAA;AAMJ;;AAHA;EACI,sBAAA;AAMJ;;AAHA;EACI,sBAAA;EACA,6BAAA;AAMJ;;AAHA;EACI,WAAA;EACA,yBAAA;EACA,WAAA;AAMJ;;AAHA;EACI,eAAA;AAMJ;;AADA;EACI,yBAAA;EAEA,gBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,6BAAA;AAGJ","sourcesContent":["@import '../../theme/mixins.scss';\n\n.filter-modal:after {\n    content: '';\n    position: absolute;\n    left: calc(90% - 8px);\n    border-style: solid;\n    border-width: 0 12px 16px;\n    border-color: #FFF transparent;\n    display: block;\n    width: 0;\n    z-index: 1;\n}\n\n.filter-modal-text {\n    font-size: 14px;\n}\n\nion-content {\n    --background: var(--ion-color-primary-contrast);\n    --color: var(--ion-text-color);\n    --padding-top: 16px;\n    --padding-bottom: 16px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n}\n\nion-list {\n    background: transparent;\n}\n\nion-item {\n    @include reset-ion-item-styles();\n}\n\nion-label {\n    --color: var(--ion-text-color);\n}\n\nion-checkbox {\n    margin-inline-end: 8px;\n}\n\nion-toggle {\n    margin-inline-end: 8px;\n    --background: rgba(0,0,0,.05);\n}\n\nhr {\n    width: 100%;\n    background-color: #eeeeee;\n    height: 2px;\n}\n\nh5.filter-header {\n    margin-top: 2px;\n}\n\n// Show overflowing elements(popqover arrow)\n\n.filter-modal .modal-wrapper {\n    overflow: auto !important;\n    // Custom property used by Ionic.\n    contain: initial;\n}\n\n.buttons-container {\n    display: flex;\n    justify-content: space-around;\n}\n","@mixin header-shadow() {\n  -webkit-box-shadow: 0 6px 6px 0 rgba(238,238,238,1);\n  -moz-box-shadow: 0 6px 6px 0 rgba(238,238,238,1);\n  box-shadow: 0 6px 6px 0 rgba(238,238,238,1);\n}\n\n@mixin header-light-shadow() {\n  -webkit-box-shadow: 0 2px 2px -2px rgba(238,238,238,1);\n  -moz-box-shadow: 0 2px 2px -2px rgba(238,238,238,1);\n  box-shadow: 0 2px 2px -2px rgba(238,238,238,1);\n}\n\n@mixin common-ion-content-styles() {\n  padding: 0 !important;\n\n  --color: var(--ion-color-light-contrast);\n  --background: var(--ion-color-chat-content-background);\n\n  @media (prefers-color-scheme: dark) {\n    --color: var(--ion-text-color);\n    --background: var(--ion-background-color);\n  }\n}\n\n@mixin common-header-toolbar-styles() {\n  font-size: 0.9rem;\n\n  --background: var(--ion-button-color-white);\n  --color: var(--ion-color-light-contrast);\n  --border-style: none;\n\n  @media (prefers-color-scheme: dark) {\n    --background: var(--ion-background-color);\n    --color: var(--ion-text-color);\n  }\n}\n\n@mixin common-header-toolbar-buttons-styles() {\n  background-color: transparent;\n\n  --color: var(--ion-color-light-contrast);\n\n  @media (prefers-color-scheme: dark) {\n    --color: var(--ion-text-color);\n  }\n}\n\n@mixin reset-ion-item-styles() {\n  border-width: 0;\n\n  --inner-border-width: 0;\n  --background: transparent;\n  --padding-start: 0;\n  --padding-end: 0;\n  --inner-padding-end: 0;\n  --ion-background-color: transparent;\n  --border-width: 0;\n}\n\n@mixin common-button-styles() {\n  height: 45px;\n  font-weight: 600;\n  font-size: 1rem;\n  text-transform: uppercase;\n\n  --border-radius: 0 !important;\n  --color: var(--ion-button-color-white);\n  --background: var(--ion-color-chat-send-button);\n  --background-hover: var(--ion-color-chat-send-button);\n\n  &:hover {\n    opacity: .7;\n  }\n}\n\n@mixin ion-segment-button-styles() {\n  min-width: 50%;\n  font-size: 12px;\n\n  --color: var(--ion-color-light-contrast);\n  --color-checked: var(--ion-color-light-contrast);\n  --border-bottom-color: var(--ion-color-light-contrast);\n\n  &.ios {\n    --color-checked: var(--ion-color-light-contrast);\n  }\n\n  &:hover {\n    --color: var(--ion-color-text-primary);\n    --color-checked: var(--ion-color-text-primary);\n  }\n\n  @media (prefers-color-scheme: dark) {\n    --color: var(--ion-text-color);\n    --color-checked: var(--ion-color-primary);\n    --border-bottom-color: var(--ion-text-color);\n  }\n}\n\n@mixin common-checkbox-styles() {\n  margin: 0 15px 0 0;\n\n  --size: 27px;\n  --background: var(--ion-color-chat-textareat-background);\n  --background-checked: var(--ion-color-chat-textareat-background);\n  --border: 1px solid var(--ion-color-input-border);\n  --border-radius: 0;\n  --border-color-checked: var(--ion-color-input-border);\n  --checkmark-color: var(--ion-color-warning-contrast);\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
